module.exports = __webpack_public_path__ + "media/images/touch/homescreen168-0b006e45469f1796eef312a960234177.png";